import privateHttpClient from '../privateHttpClient';
import { urlHttpGov } from '../../urls';
import { ContactStatus, IContact } from '../../../pages/HelpAndSupport/interfaces';
import ContactMapper from '../mappers/ContactMapper';

class HelpAndSupportService {
    private baseURL: string = `${urlHttpGov}/panel/contact`;
    private baseURLToMessage: string = `${urlHttpGov}/panel/message-contact`;

    async listContacts(cityId: number, signal: AbortSignal): Promise<IContact[]> {

        const { data } = await privateHttpClient.get(`${this.baseURL}/county_id/${cityId}`, { signal });

        return data.map((contact: any) => ContactMapper.toDomain(contact));
    }

    async createMessageContact(messageContact: FormData) {

        const { data } = await privateHttpClient.post(this.baseURLToMessage, messageContact, {
            headers: {
                "Content-Type": 'multipart/form-data'
            }
        });

        return ContactMapper.toDomain(data);
    }

    async getContactById(id: number, signal: AbortSignal): Promise<IContact> {
        const { data } = await privateHttpClient.get(`${this.baseURL}/${id}`, { signal });

        return ContactMapper.toDomain(data);
    }

    async updateStatusContact(id: number, status: ContactStatus) {
        const { data } = await privateHttpClient.put(`${this.baseURL}/${id}`, {
            status,
            response_contact: 'Alterar status'
        });

        return ContactMapper.toDomain(data);
    }

    async getTotalContacts(cityId: number, signal: AbortSignal): Promise<number> {

        const { data } = await privateHttpClient.get(`${this.baseURL}/county_id/${cityId}/total`, { signal });

        return data;
    }

    async listMessagesContact(contactId: number, signal?: AbortSignal) {
        const { data } = await privateHttpClient.get(`${this.baseURLToMessage}/contact/${contactId}`, { signal });
        return data;
    }

    deleteMessageContact(id: number) {
        return privateHttpClient.delete(`${this.baseURLToMessage}/${id}`);
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new HelpAndSupportService();
